import moment from "moment";
import { axiosGet, axiosPost } from "../../react_axios/Axios"
import {
    GET_BLOG_LIST_ACTION_TYPE, GET_BLOG_DETAILS_ACTION_TYPE, INSERT_UPDATE_BLOG_ACTION_TYPE, DELETE_BLOG_ACTION_TYPE,
    headers, getBlogListUrl, getBlogDetailsUrl, insertUpdateBlogUrl, deleteBlogUrl
} from "../../utils/constants"

export const getBlogList_action = (Title, FromDate, ToDate, isActive, StatusId) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') ? sessionStorage.getItem('UserIDSS') : null,
            Title: Title,
            FromDate: FromDate != '' && FromDate != 'Invalid date' && FromDate != null ? moment(FromDate).format('YYYY-MM-DD') : null,
            ToDate: ToDate != '' && ToDate != 'Invalid date' && ToDate != null ? moment(ToDate).format('YYYY-MM-DD') : null,
            isActive: isActive != '' ? isActive : null,
            StatusId: StatusId != '' ? StatusId : 1,
        }

        const res = await axiosGet(getBlogListUrl, mapdata, headers);
        console.log("registrationOneAdd_action res", res)

        dispatch({
            type: GET_BLOG_LIST_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getBlogDetails_action = (BlogID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') ? sessionStorage.getItem('UserIDSS') : null,
            BlogID: BlogID,
        }

        const res = await axiosGet(getBlogDetailsUrl, mapdata, headers);
        console.log("registrationOneAdd_action res", res)

        dispatch({
            type: GET_BLOG_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insertUpdateBlog_action = (BlogID, Title, Details, IsActive) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') ? sessionStorage.getItem('UserIDSS') : null,
            BlogID: BlogID,
            Title: Title,
            Details: Details,
            IsActive: IsActive != null ? IsActive : 0,
        }

        const res = await axiosPost(insertUpdateBlogUrl, mapdata, headers);
        console.log("registrationOneAdd_action res", res)

        dispatch({
            type: INSERT_UPDATE_BLOG_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const deleteBlog_action = (BlogID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') ? sessionStorage.getItem('UserIDSS') : null,
            BlogID: BlogID,
        }

        const res = await axiosGet(deleteBlogUrl, mapdata, headers);
        console.log("registrationOneAdd_action res", res)

        dispatch({
            type: DELETE_BLOG_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};